export function getDocCompletedPercent(doc) {
  const total =
    typeof doc?.totalPages === "number"
      ? doc.totalPages
      : doc?.pages?.length || 0;

  if (!total) return 0;

  const completed =
    doc?.statusCounts?.completed ??
    (doc?.pages || []).filter(
      (p) => (p.status || "").toLowerCase().trim() === "completed"
    ).length;

  return Math.round((completed / total) * 100);
}

export function isDocFullyCompleted(doc) {
  return getDocCompletedPercent(doc) === 100;
}
